<div class="app-panel app-panel--nested">
  <div class="app-panel__header">
    <h4 class="app-panel__title">{{ i18n().t('checklistCreator.definition.scaleTitle') }}</h4>
  </div>
  <div class="checklist-creator__definition-grid" [formGroup]="form()">
    <label class="app-field">
      <span class="app-field__label">{{ i18n().t('checklistCreator.fields.scaleMin') }}</span>
      <input type="number" formControlName="scaleMin" />
    </label>
    <label class="app-field">
      <span class="app-field__label">{{ i18n().t('checklistCreator.fields.scaleMax') }}</span>
      <input type="number" formControlName="scaleMax" />
    </label>
  </div>
  <div class="checklist-creator__array-section">
    <div class="app-panel__header">
      <h5 class="app-panel__title">{{ i18n().t('checklistCreator.definition.scaleRulesTitle') }}</h5>
      <p class="app-panel__meta">{{ i18n().t('checklistCreator.definition.scaleRulesMeta') }}</p>
    </div>

    <form class="checklist-creator__scale-rule-form" [formGroup]="newRuleForm">
      <div class="checklist-creator__array-row">
        <label class="app-field">
          <span class="app-field__label">{{ i18n().t('checklistCreator.fields.scaleRuleMin') }}</span>
          <input type="number" formControlName="minValue" />
        </label>
        <label class="app-field">
          <span class="app-field__label">{{ i18n().t('checklistCreator.fields.scaleRuleMax') }}</span>
          <input type="number" formControlName="maxValue" />
        </label>
        <label class="app-field">
          <span class="app-field__label">{{ i18n().t('checklistCreator.fields.scaleRuleScore') }}</span>
          <input type="number" formControlName="score" />
        </label>
      </div>
      @if (!isReadOnly()) {
        <button class="secondary-button secondary-button--indigo" type="button" (click)="addRule()">
          {{ i18n().t('checklistCreator.actions.addScaleRule') }}
        </button>
      }
    </form>

    @for (bucket of buckets().controls; track $index) {
      <div class="app-list-row checklist-creator__scale-rule-list-row" [formGroup]="asFormGroup(bucket)">
        <div class="checklist-creator__scale-rule-list-values">
          <div class="checklist-creator__scale-rule-list-item">
            <span class="checklist-creator__scale-rule-list-label">{{ i18n().t('checklistCreator.fields.scaleRuleMin') }}</span>
            <span class="checklist-creator__scale-rule-list-value">{{ asFormGroup(bucket).controls['minValue'].value }}</span>
          </div>
          <div class="checklist-creator__scale-rule-list-item">
            <span class="checklist-creator__scale-rule-list-label">{{ i18n().t('checklistCreator.fields.scaleRuleMax') }}</span>
            <span class="checklist-creator__scale-rule-list-value">{{ asFormGroup(bucket).controls['maxValue'].value }}</span>
          </div>
          <div class="checklist-creator__scale-rule-list-item">
            <span class="checklist-creator__scale-rule-list-label">{{ i18n().t('checklistCreator.fields.scaleRuleScore') }}</span>
            <span class="checklist-creator__scale-rule-list-value">{{ asFormGroup(bucket).controls['score'].value }}</span>
          </div>
        </div>
        @if (!isReadOnly()) {
          <button class="secondary-button" type="button" (click)="removeBucketRequested()($index)">
            {{ i18n().t('checklistCreator.actions.remove') }}
          </button>
        }
      </div>
    } @empty {
      <div class="app-empty-state"><span class="app-message__icon app-message__icon--info fa-solid fa-circle-info" aria-hidden="true"></span> {{ i18n().t('checklistCreator.empty.scaleRules') }}</div>
    }
  </div>
</div>
